import ModalGeneric from "components/Stacker/components/ModalGeneric/ModalGeneric"
import PropTypes from "prop-types"
import "./SizeModal.scss"

function SizeModal(props) {
  const { children = null, modalName } = props
  return (
    <div>
      <ModalGeneric name={modalName} standard>
        {children}
      </ModalGeneric>
    </div>
  )
}

SizeModal.propTypes = {
  children: PropTypes.object,
  modalName: PropTypes.string.isRequired,
}

export default SizeModal
